/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { Icon } from '../../internal/Icon';
import { ToolHardWrenchIcon16Light } from './ToolHardWrenchIcon16Light';
import { ToolHardWrenchIcon16Regular } from './ToolHardWrenchIcon16Regular';
import { ToolHardWrenchIcon16Solid } from './ToolHardWrenchIcon16Solid';
import { ToolHardWrenchIcon20Light } from './ToolHardWrenchIcon20Light';
import { ToolHardWrenchIcon20Regular } from './ToolHardWrenchIcon20Regular';
import { ToolHardWrenchIcon20Solid } from './ToolHardWrenchIcon20Solid';
import { ToolHardWrenchIcon24Regular } from './ToolHardWrenchIcon24Regular';
import { ToolHardWrenchIcon24Solid } from './ToolHardWrenchIcon24Solid';
import { ToolHardWrenchIcon32Regular } from './ToolHardWrenchIcon32Regular';
import { ToolHardWrenchIcon64Regular } from './ToolHardWrenchIcon64Regular';
var sizes = {
    16: {
        light: ToolHardWrenchIcon16Light,
        regular: ToolHardWrenchIcon16Regular,
        solid: ToolHardWrenchIcon16Solid,
    },
    20: {
        light: ToolHardWrenchIcon20Light,
        regular: ToolHardWrenchIcon20Regular,
        solid: ToolHardWrenchIcon20Solid,
    },
    24: {
        regular: ToolHardWrenchIcon24Regular,
        solid: ToolHardWrenchIcon24Solid,
    },
    32: {
        regular: ToolHardWrenchIcon32Regular,
    },
    64: {
        regular: ToolHardWrenchIcon64Regular,
    },
};
export var ToolHardWrenchIcon = forwardRef('ToolHardWrenchIcon', function (props, ref) {
    return React.createElement(Icon, __assign({ ref: ref }, props, { sizes: sizes }));
});
